import { Box, Grid, Skeleton, Stack } from '@atgfr8/atg-ui-tailwind';

const LTLQuotingLoadingSkeleton = () => (
  <form>
    <Box p={1}>
      <Stack spacing={4}>
        <Stack spacing={2}>
          <Skeleton variant="text" height={40} />
          <Skeleton variant="text" height={40} />
        </Stack>
        <Box style={{ 'flex-grow': 1 }}>
          <Grid container spacing={4}>
            <Grid item size={{ xs: 12, md: 3 }}>
              <Skeleton variant="rectangular" height={80} />
            </Grid>
            <Grid item size={{ xs: 12, md: 3 }}>
              <Skeleton variant="rectangular" height={80} />
            </Grid>
            <Grid item size={{ xs: 12, md: 3 }}>
              <Skeleton variant="rectangular" height={80} />
            </Grid>
            <Grid item size={{ xs: 12, md: 3 }}>
              <Skeleton variant="rectangular" height={80} />
            </Grid>
          </Grid>
        </Box>
        <Box style={{ 'flex-grow': 1 }}>
          <Grid container spacing={2}>
            <Grid item size={12}>
              <Skeleton variant="text" height={40} />
            </Grid>
            <Grid item size={{ xs: 12, md: 4.5 }}>
              <Skeleton variant="rectangular" height={80} />
            </Grid>
            <Grid item size={{ xs: 12, md: 4.5 }}>
              <Skeleton variant="rectangular" height={80} />
            </Grid>
            <Grid item size={{ xs: 12, md: 3 }}>
              <Skeleton variant="rectangular" height={80} />
            </Grid>
          </Grid>
        </Box>
        <Skeleton variant="rectangular" height={200} />
        <Box>
          <Skeleton variant="rectangular" height={60} />
        </Box>
      </Stack>
    </Box>
  </form>
);

export default LTLQuotingLoadingSkeleton;
